import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import styles from "./styles.module.css";
const UnderlinedLink = ({ linkTo, linkText, trackingText, onButtonClick }) => (_jsx(_Fragment, { children: _jsx(Link, { to: linkTo, children: _jsx("button", { type: "button", onClick: onButtonClick, className: `${styles.underlined_button} ${styles.cancel_subscriptions}`, "data-profileclick": trackingText, children: linkText }) }) }));
export default UnderlinedLink;
